import { createContext } from 'react';

export const DevCenterRouterContext = createContext();
